'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = thunkInjectMiddleware;
function thunkInjectMiddleware() {
  for (var _len = arguments.length, inject = Array(_len), _key = 0; _key < _len; _key++) {
    inject[_key] = arguments[_key];
  }

  return function (_ref) {
    var dispatch = _ref.dispatch;
    var getState = _ref.getState;

    return function (next) {
      return function (action) {
        if (typeof action === 'function') return action.apply(undefined, [dispatch, getState].concat(inject));
        return next(action);
      };
    };
  };
}